import { FC } from "react";
import { Box } from "@smile2impress/components";

import { IconSvgProps as Props } from "./types";

export const Icon: FC<Props> = ({ style, className, children }) => {
    if (children) {
        return (
            <Box
                as="span"
                display="inline-flex"
                style={style}
                className={className}
                sx={{
                    svg: {
                        fill: "currentColor",
                        overflow: "visible",
                    },
                    'svg[fill="transparent"], path[fill="transparent"]': {
                        fill: "transparent",
                    },
                }}
            >
                {children}
            </Box>
        );
    }
    return null;
};
